import * as React from "react";
const SvgDivider = (props) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 4, viewBox: "0 0 30 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 30, height: 4, rx: 2, fill: "#C2CFE0" }));
export default SvgDivider;
